// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Common_spinner__2Z94w","layoutWithHeader":"Common_layoutWithHeader__H_NZ-","layout":"Common_layout__33kqz","mainContainer":"Common_mainContainer__5zkjw"};